import React, { Component } from 'react'
import NumberFormatCustom from '../std/NumberFormatCustom';
import ContMessageI18N from '../../containers/ContMessageI18N';

class TestOption extends Component {

	constructor(props) {
		super(props);
		this.state = TestOption.getStateFromProps(props);
		this.onChange = props.onChange;
	}
	static getStateFromProps(props) {
		return {
			code: props.data.code,
			basicPriceInclTax: props.data.pricing.basicPriceInclTax,
			basicPriceExclTax: props.data.pricing.basicPriceExclTax,
			netPriceInclTax: props.data.pricing.netPriceInclTax,
			netPriceExclTax: props.data.pricing.netPriceExclTax,
			isPack: props.data.isPack
		};
	}
	static getDerivedStateFromProps(props, currentState) {
		if (currentState !== TestOption.getStateFromProps(props)) {
			return TestOption.getStateFromProps(props);
		}
		return null;
	}

	onChange = function (data) { }

	handleChange(data, name) {
		var updateVar = {};
		for (var key in this.state) {
			updateVar[key] = this.state[key];
		}
		updateVar[name] = data[name];
		var option = { code: updateVar.code, pricing: {} };
		if (updateVar.basicPriceInclTax != null) {
			option.pricing.basicPriceInclTax = updateVar.basicPriceInclTax * 1.0;
		}
		if (updateVar.basicPriceExclTax != null) {
			option.pricing.basicPriceExclTax = updateVar.basicPriceExclTax * 1.0;
		}
		if (updateVar.netPriceInclTax != null) {
			option.pricing.netPriceInclTax = updateVar.netPriceInclTax * 1.0;
		}
		if (updateVar.netPriceExclTax != null) {
			option.pricing.netPriceExclTax = updateVar.netPriceExclTax * 1.0;
		}
		if (updateVar.isPack != null) {
			option.isPack = updateVar.isPack;
		}
		this.onChange(option);
	}
	handleChangeGeneric = name => event => {
		if ('isPack' === name) {
			this.handleChange({ [name]: event.target.checked }, name);
		} else {
			this.handleChange({ [name]: event.target.value }, name);
		}
	}
	getLabel(fieldname, i18nKey) { return this.props.settings.isDevelopperView ? fieldname	
										: this.getMessage(i18nKey); }
	getMessage(i18nKey) { return <ContMessageI18N i18n={i18nKey} /> }

	render() {
		return (
			<React.Fragment>
				<div className="col-auto form-floating">
					<input id={`option-${this.state.code}`} type="text" className="form-control" placeholder={this.getLabel('code', 'generics.code')}
						value={this.state.code} onChange={this.handleChangeGeneric('code')} />
					<label htmlFor={`option-${this.state.code}`}>{this.getLabel('code', 'generics.code')}</label>
				</div>
				<div className="col-auto form-floating">
					<NumberFormatCustom id={`option-${this.state.code}-basicPriceInclTax`} className="form-control"
						placeholder={this.getLabel('basicPriceInclTax', 'vehicle.pricing.basicPriceInclTax')}
						value={this.state.basicPriceInclTax} onChange={this.handleChangeGeneric('basicPriceInclTax')} />
					<label htmlFor={`option-${this.state.code}-basicPriceInclTax`}>{this.getLabel('basicPriceInclTax', 'vehicle.pricing.basicPriceInclTax')}</label>
				</div>
				<div className="col-auto form-floating">
					<NumberFormatCustom id={`option-${this.state.code}-basicPriceExclTax`} className="form-control"
						placeholder={this.getLabel('basicPriceExclTax', 'vehicle.pricing.basicPriceExclTax')}
						value={this.state.basicPriceExclTax} onChange={this.handleChangeGeneric('basicPriceExclTax')} />
					<label htmlFor={`option-${this.state.code}-basicPriceExclTax`}>{this.getLabel('basicPriceExclTax', 'vehicle.pricing.basicPriceExclTax')}</label>
				</div>
				<div className="col-auto form-floating">
					<NumberFormatCustom id={`option-${this.state.code}-netPriceInclTax`} className="form-control" placeholder={this.getLabel('netPriceInclTax', 'vehicle.pricing.netPriceInclTax')}
						value={this.state.netPriceInclTax} onChange={this.handleChangeGeneric('netPriceInclTax')} />
					<label htmlFor={`option-${this.state.code}-netPriceInclTax`}>{this.getLabel('netPriceInclTax', 'vehicle.pricing.netPriceInclTax')}</label>
				</div>
				<div className="col-auto form-floating">
					<NumberFormatCustom id={`option-${this.state.code}-netPriceExclTax`} className="form-control" placeholder={this.getLabel('netPriceExclTax', 'vehicle.pricing.netPriceExclTax')}
						value={this.state.netPriceExclTax} onChange={this.handleChangeGeneric('netPriceExclTax')} />
					<label htmlFor={`option-${this.state.code}-netPriceExclTax`}>{this.getLabel('netPriceExclTax', 'vehicle.pricing.netPriceExclTax')}</label>
				</div>
				<div className="col-auto form-check">
					<input className="form-check-input" type="checkbox" value={this.state.isPack}
						id='isPack' onChange={this.handleChangeGeneric('isPack')} />
					<label className="form-check-label" htmlFor='isPack'>
						{this.getMessage('vehicle.option.isPack')}
					</label>
				</div>
			</React.Fragment>
		)
	}
}

export default (TestOption)
